import createClient from '../../apolloClient';
import QUERY_USERS from '../../query/users';

const fetchUsers = async (variables) => {
  const client = createClient();
  const result = await client.query({
    query: QUERY_USERS,
    variables,
  });
  const { users } = result?.data || {};
  if (!users?.isSuccess) throw users.message;
  return users.users;
};

export default fetchUsers;
